import addressee from '../../defaultFieldDefinitions/Addressee';
import addressLine2 from '../../defaultFieldDefinitions/AddressLine2';
import companyName from '../../defaultFieldDefinitions/CompanyName';
import county from '../../defaultFieldDefinitions/County';
import nameNumber from '../../defaultFieldDefinitions/HouseNameOrNumber';
import streetName from '../../defaultFieldDefinitions/StreetName';
import townCity from '../../defaultFieldDefinitions/TownCity';
import * as max from '../../max-length-validators';
import * as required from '../../required-validators';
import plPostCode from '../../validationByCountry/Poland/pl-postcode';

const FieldDefinitionPL = [
  addressee,
  companyName,
  streetName,
  nameNumber,
  addressLine2,
  {
    name: 'postCode',
    label: 'checkout.delivery.address.field.label.postal.code.text',
    required: true,
    maxLength: 7,
    validate: [required.postCode, max.lengthPostCode(7), plPostCode],
  },
  townCity,
  {
    ...county,
    required: true,
    validate: [max.lengthAddress(35), required.county],
  },
];

export default FieldDefinitionPL;
